import React from "react";
import { Descriptions, Typography } from "antd";
const { Title } = Typography;

const AnswerBotPlanMarkupUpdate = ({ resource }) => {
  return (
    <>
      <Title level={4}>Order Information</Title>
      <Descriptions column={1} layout="vertical" size="small">
        <Descriptions.Item label="Purpose">
          {resource.old_plan_id ? 'Update Plan Markup' : 'Create Plan Markup'}
        </Descriptions.Item>
        <Descriptions.Item label="Name on Subaccount">{resource.name_on_subaccount}</Descriptions.Item>
        <Descriptions.Item label="Email on Subaccount">{resource.email_on_subaccount}</Descriptions.Item>
        <Descriptions.Item label="Subaccount ID on Synthflow">{resource.subaccount_id_on_synthflow}</Descriptions.Item>
        <Descriptions.Item label="Product Subscription ID">{resource.product_subscription_id}</Descriptions.Item>
      </Descriptions>

      <Title level={4}>Plan Change Details</Title>
      <Descriptions column={1} layout="vertical" size="small">
        {resource.old_plan_id && <Descriptions.Item label="Old Plan ID">{resource.old_plan_id}</Descriptions.Item>}
        {resource.old_minutes && <Descriptions.Item label="Old Minutes">{resource.old_minutes}</Descriptions.Item>}
        {resource.old_price_per_minute && <Descriptions.Item label="Old Price per Minute">${resource.old_price_per_minute}</Descriptions.Item>}
        <Descriptions.Item label="New Plan ID">{resource.new_plan_id}</Descriptions.Item>
        <Descriptions.Item label="New Minutes">{resource.new_minutes}</Descriptions.Item>
        <Descriptions.Item label="New Price per Minute">${resource.new_price_per_minute}</Descriptions.Item>
      </Descriptions>

      <Title level={4}>Notes</Title>
      <Descriptions column={1} layout="vertical" size="small">
        <Descriptions.Item label="Create Flow">
          Go to Synthflow, load the subaccount using the ID provided here, and assign the given pricing model ID to that subaccount.
        </Descriptions.Item>
        <Descriptions.Item label="Update Flow">
          Go to Synthflow, load the subaccount using the ID provided here, and please ensure that the customer has selected the specified plan and activated it. If not, kindly activate it on their behalf.
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

export default AnswerBotPlanMarkupUpdate; 